var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewEyeIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78327 3.2821C3.4697 3.2821 0.282043 9.09789 0.282043 9.09789C0.282043 9.09789 3.46236 14.9137 8.78327 14.9137C14.1042 14.9137 17.282 9.09789 17.282 9.09789C17.282 9.09789 14.1017 3.2821 8.78082 3.2821H8.78327ZM8.78327 13.2524C6.44451 13.2524 4.52409 11.3731 4.52409 9.09789C4.52409 6.8227 6.43717 4.9434 8.77348 4.9434C11.1098 4.9434 13.0327 6.81267 13.0327 9.09789C13.0327 11.3831 11.1294 13.2524 8.78327 13.2524ZM11.3324 9.09789C11.3324 10.5512 10.0578 11.5911 8.78327 11.5911C7.29341 11.5911 6.23657 10.5512 6.23657 9.09789C6.262 8.42567 6.54219 7.79006 7.01767 7.32597C7.49315 6.86187 8.1265 6.60584 8.78327 6.61221C10.0578 6.61221 11.3324 7.86508 11.3324 9.10541",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEyeIcons);
export default __webpack_public_path__ + "static/media/view-eye-icons.6d1d004a142698c3aa8fde3633e383ff.svg";
export { ForwardRef as ReactComponent };